module.exports = __webpack_public_path__ + "static/TED2018-7b601066a1b4523b4b7bb40ef8f7db58.jpg";